// Gate-to-Center mapping
export const GATE_TO_CENTER = {
  // Head (Kopf)
  64: 'head', 61: 'head', 63: 'head',
  // Ajna
  47: 'ajna', 24: 'ajna', 4: 'ajna', 17: 'ajna', 11: 'ajna', 43: 'ajna',
  // Throat (Kehle)
  62: 'throat', 23: 'throat', 56: 'throat', 35: 'throat', 12: 'throat',
  45: 'throat', 33: 'throat', 8: 'throat', 31: 'throat', 20: 'throat', 16: 'throat',
  // G (Self/Identity)
  7: 'g', 1: 'g', 13: 'g', 25: 'g', 46: 'g', 2: 'g', 15: 'g', 10: 'g',
  // Heart/Ego
  21: 'ego', 51: 'ego', 26: 'ego', 40: 'ego',
  // Sacral (Sakral)
  5: 'sacral', 14: 'sacral', 29: 'sacral', 59: 'sacral', 9: 'sacral',
  3: 'sacral', 42: 'sacral', 27: 'sacral', 34: 'sacral',
  // Spleen (Milz)
  48: 'spleen', 57: 'spleen', 44: 'spleen', 50: 'spleen', 32: 'spleen',
  28: 'spleen', 18: 'spleen',
  // Solar Plexus (Solarplexus)
  6: 'solarplexus', 37: 'solarplexus', 22: 'solarplexus', 36: 'solarplexus',
  49: 'solarplexus', 55: 'solarplexus', 30: 'solarplexus',
  // Root (Wurzel)
  58: 'root', 38: 'root', 54: 'root', 53: 'root', 60: 'root',
  52: 'root', 19: 'root', 39: 'root', 41: 'root'
};

// Mandala sequence starting from Gate 41 at 302.0° ecliptic longitude
export const MANDALA_SEQUENCE = [
  41, 19, 13, 49, 30, 55, 37, 63, 22, 36, 25, 17, 21, 51, 42, 3,
  27, 24, 2, 23, 8, 20, 16, 35, 45, 12, 15, 52, 39, 53, 62, 56,
  31, 33, 7, 4, 29, 59, 40, 64, 47, 6, 46, 18, 48, 57, 32, 50,
  28, 44, 1, 43, 14, 34, 9, 5, 26, 11, 10, 58, 38, 54, 61, 60
];

export const MANDALA_START = 302.0; // Gate 41 starts at 302.0° ecliptic

// Each gate spans exactly 5.625° (360/64)
export const GATE_DEGREE_WIDTH = 360 / 64; // 5.625°

// Each line within a gate spans 0.9375° (5.625/6)
export const LINE_DEGREE_WIDTH = GATE_DEGREE_WIDTH / 6; // 0.9375°

// Gate names (numbered 1-64)
export const GATE_NAMES = {
  1: 'Einheit', 2: 'Das Licht des Selbst', 3: 'Die Schwelle', 4: 'Die Närrische Verrücktheit',
  5: 'Das Warten', 6: 'Konflikt', 7: 'Der Verwalter', 8: 'Bündigung', 9: 'Der Fokus', 10: 'Treue',
  11: 'Friede', 12: 'Das Bewahrte', 13: 'Der Hörer', 14: 'Großmacht', 15: 'Demut', 16: 'Die Voraussicht',
  17: 'Meinung', 18: 'Korrektur', 19: 'Die Stütze', 20: 'Das Joch', 21: 'Die Kontrolle des Unwirklichen',
  22: 'Gnade', 23: 'Zusammenbruch', 24: 'Rückforderung', 25: 'Unbewusstsein', 26: 'Der Große Treiber',
  27: 'Versorgt Sein', 28: 'Vorbereitung', 29: 'Das Dunkle', 30: 'Das Feuer/Das Brennen', 31: 'Das Einflussreiche',
  32: 'Kontinuität', 33: 'Rückzug', 34: 'Die Kraft des Großen', 35: 'Fortschritt', 36: 'In Dunkelheit',
  37: 'Die Familie/Der Stamm', 38: 'Der Kämpfer', 39: 'Behinderung', 40: 'Befreiung', 41: 'Das Dekrement',
  42: 'Das Zuwachs', 43: 'Das Sprengstoff', 44: 'Das Joch', 45: 'Das Sammeln', 46: 'Die Steigerung',
  47: 'Das Erzwungene', 48: 'Die Tiefe', 49: 'Die Grundlagen/Die Revolution', 50: 'Der Kessel',
  51: 'Das Aufrichten', 52: 'Der Berg', 53: 'Die Entwicklung', 54: 'Der Herabsteigende',
  55: 'Der Reichtum', 56: 'Der Wanderer', 57: 'Der Zarte Drang', 58: 'Der Lebensbejahende',
  59: 'Zerstreuung', 60: 'Grenzziehung', 61: 'Das Innerliche der Wahrheit', 62: 'Der Kleine Sieger',
  63: 'Nach der Erfüllung', 64: 'Vor der Erfüllung'
};

// Each color within a line spans 0.15625° (0.9375 / 6)
export const COLOR_DEGREE_WIDTH = LINE_DEGREE_WIDTH / 6; // 0.15625°

// Each tone within a color spans ~0.026042° (0.15625 / 6)
export const TONE_DEGREE_WIDTH = COLOR_DEGREE_WIDTH / 6;

// Each base within a tone spans ~0.005208° (0.026042 / 5)
export const BASE_DEGREE_WIDTH = TONE_DEGREE_WIDTH / 5;

// Find gate number, line, color, tone, and base from ecliptic degree
export function getGateAndLine(eclipticDegree) {
  // Normalize to 0-360 range
  let normalizedDegree = eclipticDegree % 360;
  if (normalizedDegree < 0) {
    normalizedDegree += 360;
  }

  // Calculate offset from mandala start
  let offset = (normalizedDegree - MANDALA_START + 360) % 360;

  // Find gate index in mandala
  const gateIndex = Math.floor(offset / GATE_DEGREE_WIDTH);
  const gateNumber = MANDALA_SEQUENCE[gateIndex % 64];

  // Find line within gate
  const degreeWithinGate = offset % GATE_DEGREE_WIDTH;
  const lineNumber = Math.floor(degreeWithinGate / LINE_DEGREE_WIDTH) + 1; // Lines are 1-6

  // Find color within line (1-6)
  const degreeWithinLine = degreeWithinGate % LINE_DEGREE_WIDTH;
  const colorNumber = Math.floor(degreeWithinLine / COLOR_DEGREE_WIDTH) + 1;

  // Find tone within color (1-6)
  const degreeWithinColor = degreeWithinLine % COLOR_DEGREE_WIDTH;
  const toneNumber = Math.floor(degreeWithinColor / TONE_DEGREE_WIDTH) + 1;

  // Find base within tone (1-5)
  const degreeWithinTone = degreeWithinColor % TONE_DEGREE_WIDTH;
  const baseNumber = Math.floor(degreeWithinTone / BASE_DEGREE_WIDTH) + 1;

  return {
    gate: gateNumber,
    line: Math.max(1, Math.min(6, lineNumber)),
    color: Math.max(1, Math.min(6, colorNumber)),
    tone: Math.max(1, Math.min(6, toneNumber)),
    base: Math.max(1, Math.min(5, baseNumber))
  };
}

// Reverse: get ecliptic degree from gate number and line
export function getDegreeFromGateAndLine(gateNumber, line = 1) {
  const gateIndex = MANDALA_SEQUENCE.indexOf(gateNumber);
  if (gateIndex === -1) {
    throw new Error(`Gate ${gateNumber} not found in mandala sequence`);
  }

  const lineNum = Math.max(1, Math.min(6, line));
  const degreeWithinGate = (lineNum - 1) * LINE_DEGREE_WIDTH + LINE_DEGREE_WIDTH / 2;
  const eclipticDegree = MANDALA_START + gateIndex * GATE_DEGREE_WIDTH + degreeWithinGate;

  return eclipticDegree % 360;
}

// Get center display name
export const CENTER_NAMES = {
  head: 'Kopf',
  ajna: 'Ajna',
  throat: 'Kehle',
  g: 'G (Selbst)',
  ego: 'Ego / Wille',
  heart: 'Ego / Wille', // Alias for ego
  sacral: 'Sakral',
  spleen: 'Milz',
  solarplexus: 'Solarplexus',
  root: 'Wurzel'
};

// Get all gates for a specific center
export function getGatesForCenter(centerName) {
  return Object.entries(GATE_TO_CENTER)
    .filter(([_, center]) => center === centerName)
    .map(([gate, _]) => parseInt(gate));
}

// Check if a gate is defined in personality or design
export function isGateDefined(gate, personalityGates, designGates) {
  const inPersonality = personalityGates.includes(gate);
  const inDesign = designGates.includes(gate);
  return { inPersonality, inDesign, defined: inPersonality || inDesign };
}
